import React from "react"
import {CustomHeaderWrapper} from './style.jsx'
import {isApplyCustomLayout} from '../const.js'
const Header = ({children}) => {
  return <CustomHeaderWrapper isApplyCustomLayout={isApplyCustomLayout}>{children}</CustomHeaderWrapper>
}

export default Header



// WEBPACK FOOTER //
// ./src/common/custom-layout/CustomHeader/index.js